<template>
  <div>
    <button class="listen-btn" @click="togglePlay">
      {{ isPlaying ? '🎵 ' + currentSongName : '🎧 Listen Now' }}
    </button>
    <audio
      ref="player"
      :src="playlist[currentTrackIndex]"
      @ended="nextTrack"
    ></audio>
  </div>
</template>

<script>
export default {
  name: 'MusicPlayer',

  data() {
    return {
      playlist: [
        '/media/mp3/1.mp3',
        '/media/mp3/2.mp3',
        '/media/mp3/3.mp3',
        '/media/mp3/4.mp3',
        '/media/mp3/5.mp3',
        '/media/mp3/6.mp3',
        '/media/mp3/7.mp3',
        '/media/mp3/8.mp3',
      ],
      titles: [
        'Survive The Night',
        'Lost Heaven',
        'The One',
        "Don't Give Up",
        "Devil's Heart",
        'Keeper Of Faith',
        'Never Surrender',
        'Queen Of The Damned',
      ],
      shuffledOrder: [],
      currentShuffledIndex: 0,
      isPlaying: false,
    };
  },

  computed: {
    currentTrackIndex() {
      return this.shuffledOrder[this.currentShuffledIndex] || 0;
    },
    currentSongName() {
      const index = this.currentTrackIndex;
      return this.titles[index] || 'Unknown Track';
    },
  },

  mounted() {
    this.initShuffle();
  },

  methods: {
    togglePlay() {
      const player = this.$refs.player;

      if (this.isPlaying) {
        player.pause();
        this.isPlaying = false;
      } else {
        player.play().catch((err) => {
          console.warn('Playback error:', err);
        });
        this.isPlaying = true;
      }
    },

    nextTrack() {
      this.currentShuffledIndex++;

      if (this.currentShuffledIndex >= this.shuffledOrder.length) {
        this.initShuffle();
      }

      const player = this.$refs.player;
      player.pause();
      player.src = this.playlist[this.currentTrackIndex];
      player.load();

      player.oncanplay = () => {
        player.play().catch((err) => {
          console.warn('Autoplay failed:', err);
        });
        this.isPlaying = true;
      };
    },

    initShuffle() {
      const indices = this.playlist.map((_, i) => i);
      this.shuffledOrder = this.shuffleArray(indices);
      this.currentShuffledIndex = 0;
    },

    shuffleArray(array) {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    },
  },
};
</script>

<style scoped>
.listen-btn {
  background: linear-gradient(45deg, #0f0f0f, #1f3b70);
  border: 1px solid #666;
  padding: 0.5rem 1rem;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
}

.listen-btn:hover {
  background: linear-gradient(45deg, #333, #666);
  box-shadow: 0 0 10px rgba(100, 100, 255, 0.3);
}
</style>
